import NewTripBuilderContainer from './NewTripBuilderContainer';

export default NewTripBuilderContainer;
